import {DefaultInteraction} from "./interaction";


export class JoinMeetingPrompt extends DefaultInteraction {

	interactionData
	metadata = {}

	constructor(props) {
		super(props);
	}

	key() {
		return "join_meeting_prompt"
	}

	runInteraction(interactionData, metadata, onSuccess, onError) {
		this._emitJoinMeetingEvent(interactionData.room_id)
		return true
	}


	onProximityExit(interactable) {
		window.dispatchEvent(new CustomEvent('interaction-out', {
			detail: {
				action_type: this.key(),
			}
		}))
	}


	onProximityEnter(interaction, interactable) {
		this._emitJoinMeetingEvent(interaction.data.room_id)
	}

	_emitJoinMeetingEvent(roomID) {
		window.dispatchEvent(new CustomEvent('interaction-ui', {
			detail: {
				action_type: this.key(),
				data: {
					room_id: roomID
				}
			}
		}))
	}
}